<app-plain-toolbar [icon_button_class]="'hmn-icon__button-accent-contrast'"></app-plain-toolbar>

<div class="hmn-width__full hmn-height__full hmn-background__primary-contrast hmn-row">
  <div class="hmn-margin__auto hmn-form__standalone hmn-padding__x4">
    <h3 class="hmn-color__primary hmn-margin__x4-bottom">{{ 'AUTH.WELCOME_MESSAGE' | translate }}</h3>
    <app-auth-signin-form></app-auth-signin-form>
  </div>
</div>

<app-plain-footer [background]="'hmn-background__primary-contrast'"></app-plain-footer>
